var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 1,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 6.54545,
    height: 6.54545,
    rx: 1,
    stroke: "#573A78",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHomeIcon);
export default __webpack_public_path__ + "static/media/newHomeIcon.ed68d73764f2a2d604da108782d66d0a.svg";
export { ForwardRef as ReactComponent };